<form class="modal-body" [formGroup]="form" (ngSubmit)="duplicate()" novalidate>
  <p class="centermodal__title">{{ 'model.duplicateModel' | translate }}</p>

  <div class="centermodal__form" formGroupName="template">
    <label class="field__holder" [appFormControlWrap]="form.get('template.name')">
      <input type="text" class="field" formControlName="name" name="name" autocomplete="none" role="presentation" required #nameInput />
      <span class="field__placeholder">{{ 'model.modelName' | translate }}</span>
    </label>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <button type="submit" class="btn-M btn-filled" [disabled]="form.invalid || isLoading">{{ 'button.duplicate' | translate }}</button>
  </div>
</form>
